module.exports = __webpack_public_path__ + "img/JDB.746ee3d2.png";